import { render, staticRenderFns } from "./LoadingBlock.vue?vue&type=template&id=36229bb4&lang=html&"
import script from "./LoadingBlock.vue?vue&type=script&lang=js&"
export * from "./LoadingBlock.vue?vue&type=script&lang=js&"
import style0 from "./LoadingBlock.vue?vue&type=style&index=0&id=36229bb4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports